/** Site-wide constants. Shared by the app and the prerender script. */

export const SITE_NAME = 'Tiny Boss'
export const SITE_URL = 'https://tinyboss.app'
export const CONTACT_EMAIL = 'hey@tinybossapp.com'

export type RouteMeta = {
  path: string
  title: string
  description: string
}

/** Per-route <head> content. The prerender script bakes these into the static
 *  HTML; useDocumentTitle keeps them in sync across client-side navigation. */
export const ROUTE_META: Record<string, RouteMeta> = {
  '/': {
    path: '/',
    title: 'Tiny Boss — Run the nursery like a boss',
    description:
      'Feeds, sleep, diapers, and more: by voice or two taps, synced with everyone who helps. Join the early access waitlist.',
  },
  '/privacy': {
    path: '/privacy',
    title: 'Privacy Policy — Tiny Boss',
    description: 'What Tiny Boss collects, why, and what we never do with it.',
  },
  '/terms': {
    path: '/terms',
    title: 'Terms of Service — Tiny Boss',
    description: 'The terms that apply when you use Tiny Boss.',
  },
  '/404': {
    path: '/404',
    title: 'Page not found — Tiny Boss',
    description: "This page doesn't exist — or it's asleep.",
  },
}
